module.exports = __webpack_public_path__ + "img/shop2.2577204d.png";